// removed by extract-text-webpack-plugin
module.exports = {"root":"_12lnH59","list":"XrOi16n","item":"_24OAzEF","link":"_2MLTSiu","link_isActive":"_36UKuB5"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Header/components/Navigation/Navigation.less
 ** module id = 725
 ** module chunks = 0
 **/